import {
  Button,
  IconCopy,
  IconMinus,
  IconPlus,
  Modal,
  Select,
  Table,
  TextBox,
  RadioButton,
  RadioGroup,
  IconPencil, 
  Tooltip
} from "@veneer/core";
import { Row, Col } from "react-bootstrap";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { openDB } from "idb";
import CreateNewContact from "./address/create-new-contact";
import CreateAlternateContact from "./address/create-alternate-contact";
import "./bulk-upload-tabs.css";
import "./bulk-uploads.css"
import { apiGetWithHeader, apiPost } from "@services/service";
import { GET_STATIC_INTENT, POST_CASECREATE_BULKUPLOAD, POST_UIDS_ISSUE_DSC } from "services";
import { onSearchDropDown } from "utils";
import { toast } from "react-toastify";
import EquipmentContact from "./modal/equipment-contact";
import { RootState } from "@store/store";
import { useAppDispatch, useAppSelector } from "@store/hooks";
import AddressModal from "./modal/equipment-address/equipment-address-modal";
import { POST_SHIPPING_ADDRESS_CHANGE } from "@constants/end-points";
import { fetchCaseInfo, fetchProductInfo } from "@store/reducers/create-case-apis";
import { fetchContactDetails } from "@services/fetch-contact-details-info";
import PartShippingAddressModal from "./modal/part-shipping-address-modal";
import Loader from "../shared-components/loader/loader";
import { setLoading } from "@store/reducers/loadingSlice";

interface RowData {
  id: number;
  serialNumber: string;
  productNumber: string;
  caseTitle: string[];
  issueDescription: string;
  contact: string[];
  contactData: string[];
  site: string[];
  siteAddress?: any;
  bindPinList:[];
  equipmentContact: string[];
  partShippingAddress: string[];
  alternateContact: string[];
  alternateContactData: any[];
  caseTitleOptions: any[];
  caseTitleOptionsFiltered: any[];
  equipmentContactData:any[];
  partShippingAddressData?: any;
  partShippingAddressOption?: any;

}

const DB_NAME = "bulkUploadDB";
const STORE = "rows";

const initDB = () =>
  openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "id" });
      }
    }
  });

const debounce = (fn: any, delay = 400) => {
  let timer: any;
  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

const createRow = (id: number): RowData => ({
  id,
  serialNumber: "",
  productNumber: "",
  caseTitle: [],
  issueDescription: "",
  contact: [],
  contactData: [],
  site: [],
  siteAddress:{},
  bindPinList:[],
  equipmentContact: [],
  equipmentContactData:[],
  partShippingAddress: [],
  partShippingAddressData: {},
  alternateContact: [],
  alternateContactData: [],
  caseTitleOptions: [],
  caseTitleOptionsFiltered: []
});

const isEmpty = (v?: string) => !v?.trim();

const BulkUploads: React.FC<{ dropdown: any[]; siteSubAccount: any[] }> = ({
  dropdown,
  siteSubAccount
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch()
  const [rows, setRows] = useState<RowData[]>([]);
  const [errors, setErrors] = useState<Record<number, any>>({});
  const [open, setOpen] = useState(false);
  const [openAlternateContactModal, setOpenAlternateContactModal] = useState(false);
  const [openPartShippingModal, setOpenPartShippingModal] = useState(false);
  const [openEquipmentContact, setOpenEquipmentContact] = useState(false);
  const [count, setCount] = useState(0);
  const [openSiteModal, setOpenSiteModal] = useState(false);
  const [selectedSiteRow, setSelectedSiteRow] = useState<RowData | null>(null);
  const [equipmentContact, setEquipmentContact] = useState<any>(null);
  const [contactRowId, setContactRowId] = useState<any>(null);
  const [alternateContactRowId, setAlternateContactRowId] = useState<any>(null);
  const [equipmentContactRowId, setEquipmentContactRowId] = useState<any>(null);
  const [partShippingAddressRowId, setPartShippingAddressRowId] = useState<any>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loadingStates, setLoadingStates] = useState<Record<number, { uids?: boolean; site?: boolean; contact?: boolean }>>({});
  // Row-specific filtered dropdown options
  const [filteredContactOptions, setFilteredContactOptions] = useState<Record<number, any[]>>({});
  const [filteredEquipmentContactOptions, setFilteredEquipmentContactOptions] = useState<Record<number, any[]>>({});
  const [filteredAlternateContactOptions, setFilteredAlternateContactOptions] = useState<Record<number, any[]>>({});
  const [filteredSiteOptions, setFilteredSiteOptions] = useState<Record<number, any[]>>({});
  const { countryCodes, countryList, savedContactsDropDown } = useAppSelector(
      (state: RootState) => state.createCaseAPI
    );
  const { isLoading } = useAppSelector((state: RootState) => state.loading);
  useEffect(() => {
    loadRows();
  }, []);
  useEffect(() => {
  if (openPartShippingModal && partShippingAddressRowId) {
    updateRow(partShippingAddressRowId, "partShippingAddress", []);
    updateRow(partShippingAddressRowId, "partShippingAddressData", {});
    updateRow(partShippingAddressRowId, "partShippingAddressOption", null);
  }
}, [openPartShippingModal]);
  // Initialize filtered options for each row when dropdown data changes
  useEffect(() => {
    const newFilteredContactOptions: Record<number, any[]> = {};
    const newFilteredEquipmentContactOptions: Record<number, any[]> = {};
    const newFilteredAlternateContactOptions: Record<number, any[]> = {};
    
    rows.forEach(row => {
      newFilteredContactOptions[row.id] = dropdown;
      newFilteredEquipmentContactOptions[row.id] = dropdown;
      newFilteredAlternateContactOptions[row.id] = dropdown;
    });
    
    setFilteredContactOptions(newFilteredContactOptions);
    setFilteredEquipmentContactOptions(newFilteredEquipmentContactOptions);
    setFilteredAlternateContactOptions(newFilteredAlternateContactOptions);
  }, [dropdown, rows]);

  useEffect(() => {
    const newFilteredSiteOptions: Record<number, any[]> = {};
    
    rows.forEach(row => {
      newFilteredSiteOptions[row.id] = siteSubAccount;
    });
    
    setFilteredSiteOptions(newFilteredSiteOptions);
  }, [siteSubAccount, rows]);


   useEffect(() => {
    let payload = {
      contactid: "85680c15-7814-e711-80fc-5065f38ad971",
      accountid: "f16eeb64-73fc-e611-80fa-5065f38ad971",
    };dispatch(fetchCaseInfo(payload)); // case info data is required to get the country list for dropdown, so fetching it on component load
  }, [dispatch]);
  const loadRows = async () => {
    const db = await initDB();
    const saved = await db.getAll(STORE);

    if (saved.length) {
      const safeRows = saved.map((r: any) => ({
        ...createRow(r.id),
        ...r
      }));
      setRows(safeRows);
    } else {
      addRow();
    }
  };

  const saveRow = async (row: RowData) => {
    const db = await initDB();
    await db.put(STORE, row);
  };


  const debouncedSave = useCallback(debounce(saveRow, 400), []);

  const validateRow = (row: RowData) => {
    const e: any = {};

    if (isEmpty(row.serialNumber)) e.serialNumber = "Serial number is required";
    if (isEmpty(row.productNumber)) e.productNumber = "Product number is required";
    if (!row.caseTitle?.length) e.caseTitle = "Case title is required";
    if (isEmpty(row.issueDescription)) e.issueDescription = "Description is required";
    if (!row.contact?.length) e.contact = "Contact is required";
    if (!row.site?.length) e.site = "Site is required";
    if (!row.equipmentContact?.length) e.equipmentContact = "Equipment Contact is required";

    return e;
  };

  const MAX_ROWS = 250;

  const addRow = () => {
    if (rows.length >= MAX_ROWS) {
      toast.error(t('HPI.BulkUpload.MaxRowLimit', { defaultValue: `You can add a maximum of ${MAX_ROWS} rows.` }));
      return;
    }
    
    const newRowId = Date.now();
    setRows(prev => [...prev, createRow(newRowId)]);
    
    // Initialize filtered options for new row
    setFilteredContactOptions(prev => ({ ...prev, [newRowId]: dropdown }));
    setFilteredEquipmentContactOptions(prev => ({ ...prev, [newRowId]: dropdown }));
    setFilteredAlternateContactOptions(prev => ({ ...prev, [newRowId]: dropdown }));
    setFilteredSiteOptions(prev => ({ ...prev, [newRowId]: siteSubAccount }));
  };

  const cloneRow = (row: RowData) => {
    if (rows.length >= MAX_ROWS) {
      toast.error(t('HPI.BulkUpload.MaxRowLimit', { defaultValue: `You can add a maximum of ${MAX_ROWS} rows.` }));
      return;
    }
    const newRowId = Date.now();
    const newRow = { 
      ...row, 
      id: newRowId,
      serialNumber: "", // Clear serial number for cloned row
      productNumber: "" // Clear product number for cloned row
    };
    setRows(prev => {
      const index = prev.findIndex(r => r.id === row.id);
      const updated = [...prev];
      updated.splice(index + 1, 0, newRow);
      return updated;
    });
    
    // Initialize filtered options for cloned row
    setFilteredContactOptions(prev => ({ ...prev, [newRowId]: dropdown }));
    setFilteredEquipmentContactOptions(prev => ({ ...prev, [newRowId]: dropdown }));
    setFilteredAlternateContactOptions(prev => ({ ...prev, [newRowId]: dropdown }));
    setFilteredSiteOptions(prev => ({ ...prev, [newRowId]: siteSubAccount }));
    
    saveRow(newRow);
  };

  const removeRow = async (id: number) => {
    // if (rows.length === 1) {
      
    // }
    setRows(prev => prev.filter(r => r.id !== id));
    
    // Clean up filtered options for removed row
    setFilteredContactOptions(prev => {
      const { [id]: removed, ...rest } = prev;
      return rest;
    });
    setFilteredEquipmentContactOptions(prev => {
      const { [id]: removed, ...rest } = prev;
      return rest;
    });
    setFilteredAlternateContactOptions(prev => {
      const { [id]: removed, ...rest } = prev;
      return rest;
    });
    setFilteredSiteOptions(prev => {
      const { [id]: removed, ...rest } = prev;
      return rest;
    });
    
    const db = await initDB();
    await db.delete(STORE, id);
    if (rows.length === 1) {
      addRow()
    }
  };

  const updateRow = (id: number, key: keyof RowData, value: any) => {
    setRows(prev =>
      prev.map(row => {
        if (row.id !== id) return row;
        const safeValue =
        key === "site" && !Array.isArray(value)
          ? []
          : value;
        const updated = { ...row, [key]: safeValue };
        debouncedSave(updated);
        return updated;
      })
    );
  };

  const clearFieldError = (rowId: number, fieldName: string) => {
    setErrors(prev => {
      if (!prev[rowId]) return prev;
      const updatedRowErrors = { ...prev[rowId] };
      delete updatedRowErrors[fieldName];
      
      if (Object.keys(updatedRowErrors).length === 0) {
        const { [rowId]: removed, ...rest } = prev;
        return rest;
      }
      
      return {
        ...prev,
        [rowId]: updatedRowErrors
      };
    });
  };

  const handleSubmit = async () => {
    const newErrors: any = {};
    let hasError = false;

    rows.forEach(row => {
      const e = validateRow(row);
      if (Object.keys(e).length) {
        hasError = true;
        newErrors[row.id] = e;
      }
    });

    setErrors(newErrors);
    if (hasError) return;

    ;
    submitBulkData(rows)
    };

  function removeIfExists(data: any[]) {
    return data.map((item: any) => {
      const newItem = { ...item };

      if (newItem.caseTitleOptions?.length) {
        delete newItem.caseTitleOptions;
      }

      if (newItem.caseTitleOptionsFiltered?.length) {
        delete newItem.caseTitleOptionsFiltered;
      }

      return newItem;
    });
  }
  // POST_CASECREATE_BULKUPLOAD

  const submitBulkData = async (rows: any) => {
    try {
      setIsSubmitting(true);
      dispatch(setLoading(true));
      let cleanedRows = removeIfExists(rows);
      let payload = {
        "0": cleanedRows
      };
      
      const response: any = await apiPost(POST_CASECREATE_BULKUPLOAD, payload);
      if (response?.data) {
        console.log('API Response:', response.data, response);
        toast.success(response.data.Message);
        
        // Clear IndexedDB data after successful submission
        const db = await initDB();
        await db.clear(STORE);
        
        // Reset rows to single empty row
        setRows([createRow(Date.now())]);
        
        // Clear any existing errors
        setErrors({});
      }
    } catch (error) {
      console.error('Error submitting bulk data:', error);
      toast.error("Failed to submit bulk data. Please try again.");
    } finally {
      setIsSubmitting(false);
      dispatch(setLoading(false));
    }
  }

  const getStaticUids = useCallback( async () => {
    const response: any = await apiGetWithHeader(GET_STATIC_INTENT);
    const data = response?.data?.intentData || [];
    return data.map((item: any) => ({
      label: item.IntentDescription,
      value: item.IntentDescription
    }));
  }, []);

  const uidsApi = async (id: number, desc: string) => {
    try {
      if (desc?.length){
        // Set loading state for this specific row
        setLoadingStates(prev => ({
          ...prev,
          [id]: { ...prev[id], uids: true }
        })); 
        if (count > 2) {
        let staticUids = await getStaticUids();
        setRows(prev =>
          prev.map(row => {
            if (row.id !== id) return row;
            const updated = {
              ...row,
              caseTitle:[],
              caseTitleOptions: [...staticUids],
              caseTitleOptionsFiltered: [...staticUids]
            };
            debouncedSave(updated);
            return updated;
          })
        )
        } else {
          const res = await apiPost(POST_UIDS_ISSUE_DSC, { issuedescription: desc });
          const intentData = res?.data?.intentData || [];
          const result = intentData.map((item: any) => ({
            label: item.PredictedIntent,
            value: item.PredictedIntent
          }));
          const checkToVague = result.some((item: any) => item.label === "too vague" || item.value === "too vague");
          if (checkToVague) {
            toast.error(t('HPI.CreateCase.IssueDescription.error', { defaultValue: 'Refine your issue description for better suggestions' }));
            setCount(count + 1);
            if (count >= 2) {
              let staticUids = await getStaticUids();
              setRows(prev =>
                prev.map(row => {
                  if (row.id !== id) return row;
                  const updated = {
                    ...row,
                    caseTitle: [],
                    caseTitleOptions: [...staticUids],
                    caseTitleOptionsFiltered: [...staticUids]
                  };
                  debouncedSave(updated);
                  return updated;
                }))
            }
            setCount(1)
            } else {
            let staticUids = await getStaticUids();
            setRows(prev =>
              prev.map(row => {
                if (row.id !== id) return row;
                const updated = {
                  ...row,
                  caseTitle: result.length ? [result[0].value] : [],
                  caseTitleOptions: [...result, ...staticUids],
                  caseTitleOptionsFiltered: [...result, ...staticUids]
                };
                debouncedSave(updated);
                return updated;
              })
            );
            }
            setCount(1);
        }
    }
    } catch (error) {
      console.error('Error fetching case title suggestions:', error);
    } finally {
      // Clear loading state for this row
      setLoadingStates(prev => ({
        ...prev,
        [id]: { ...prev[id], uids: false }
      }));
    }
  };
  const fetchSiteNameInfo = useCallback(async (payload: any, rowId?: number) => {
  try {
    // Set loading state for this specific row
    if (rowId) {
      setLoadingStates(prev => ({
        ...prev,
        [rowId]: { ...prev[rowId], site: true }
      }));
    }
    
    const response = await apiPost(POST_SHIPPING_ADDRESS_CHANGE, payload);

  const rawAddress = response?.data?.addressdata;
  const rawBindPin = response?.data?.bindPinList;

  const address =
    typeof rawAddress === "string"
      ? JSON.parse(rawAddress || "[]")[0] || {}
      : rawAddress?.[0] || {};

  const bindPin =
    typeof rawBindPin === "string"
      ? JSON.parse(rawBindPin || "[]")
      : rawBindPin || [];

    return { address, bindPin };
  } catch (error) {
    console.error('Error fetching site info:', error);
    toast.error("Failed to fetch site information. Please try again.");
    return { address: {}, bindPin: [] };
  } finally {
    // Clear loading state for this row
    if (rowId) {
      setLoadingStates(prev => ({
        ...prev,
        [rowId]: { ...prev[rowId], site: false }
      }));
    }
  }
}, []);


  const errorCount = useMemo(
    () =>
      Object.values(errors).reduce(
        (sum: number, row: any) => sum + Object.keys(row).length,
        0
      ),
    [errors]
  );

  const preferences = {
    width: [
      { columnId: 'rowIndex', width: 60 },
      { columnId: 'serialNumber', width: 160 },
      { columnId: 'productNumber', width: 160 },
      { columnId: 'issueDescription', width: 300 },
      { columnId: 'caseTitle', width: 160 },
      { columnId: 'contact', width: 160 },
      { columnId: 'equipmentContact', width: 160 },
      { columnId: 'site', width: 160 },
      { columnId: 'alternateContact', width: 160 },
      { columnId: 'partShippingAddress', width: 160 },
    ]
  };
  const requiredLabel = <span style={{ color: 'red' }}> *</span>;

  const columns = [
    { id: "actions", className: "bulk-upload-required-field", label: t('HPI.BulkUpload.OthersDetails', { defaultValue: "Others Details" })   },
    { id: "rowIndex", label: t('HPI.BulkUpload.RowIndex', { defaultValue: "Row Index" })  },
    { id: "serialNumber", label: (t('HPI.BulkUpload.SerialNumber', { defaultValue: "Serial Number" })) },
    { id: "productNumber", label: (t('HPI.BulkUpload.ProductNumber', { defaultValue: "Product Number" }))  },
    { id: "caseTitle", label: (t('HPI.BulkUpload.IssueTitle', { defaultValue: "Issue Title" })) },
    { id: "issueDescription", label: (t('HPI.BulkUpload.IssueDescription', { defaultValue: "Issue Description" })) },
    { id: "contact", label: (t('HPI.BulkUpload.Contact', { defaultValue: "Primary Contact" })) },
    { id: "equipmentContact", label: t('HPI.BulkUpload.EquipmentContact', { defaultValue: "Equipment Contact" }) },
    { id: "site", label: (t('HPI.BulkUpload.Site', { defaultValue: "Site" }))  },
    { id: "alternateContact", label: t('HPI.BulkUpload.AlternateContact', { defaultValue: "Alternate Contact" })  },
    { id: "partShippingAddress", label: t('HPI.BulkUpload.PartsShippingAddress', { defaultValue: "Parts Shipping Address" })  },
    
  ];

  const debouncedIssueDescApi = useMemo(
    () =>
      debounce((rowId: number, desc: string) => {
        updateRow(rowId, "caseTitleOptions", [])
        updateRow(rowId, "caseTitle", []) 
        uidsApi(rowId, desc);
        // if (desc.length >=50){
        //   uidsApi(rowId, desc);
        // }
      }, 600),
    []
  );
  const tableData = rows.map((row, index) => {
    const rowErrors = errors[row.id] || {};

    return {
      id: row.id,

      actions: (
        <>
          <Button appearance="ghost" leadingIcon={<IconPlus />} onClick={addRow} disabled={rows.length >= MAX_ROWS} />
          <Button appearance="ghost" leadingIcon={<IconCopy />} onClick={() => cloneRow(row)} disabled={rows.length >= MAX_ROWS} />
          <Button appearance="ghost" colorScheme="negative" leadingIcon={<IconMinus />} onClick={() => removeRow(row.id)} />
        </>
      ),

      rowIndex: index + 1,

      serialNumber: (
        <TextBox
          value={row.serialNumber}
          error={!!rowErrors.serialNumber}
          title={rowErrors.serialNumber}
          onChange={v => {
            updateRow(row.id, "serialNumber", v);
            clearFieldError(row.id, "serialNumber");
          }}
        />
      ),

      productNumber: (
        <TextBox
          value={row.productNumber}
          error={!!rowErrors.productNumber}
          title={rowErrors.productNumber}
          onChange={v => {
            updateRow(row.id, "productNumber", v);
            clearFieldError(row.id, "productNumber");
          }}
        />
      ),

      caseTitle: (
        <div style={{ position: 'relative', width: '100%' }}>
          <Select
            showSearch
            options={row.caseTitleOptions}
            value={row.caseTitle}
            onChange={(opt: any) => {
              updateRow(row.id, "caseTitle", opt?.value ? [opt.value] : []);
              clearFieldError(row.id, "caseTitle");
            }}
            clearIcon={false}
            error={!!rowErrors.caseTitle}
            disabled={loadingStates[row.id]?.uids}
            className={!!rowErrors.caseTitle?"case-title-select":""}
            onSearch={(v: any) =>
              updateRow(
                row.id,
                "caseTitleOptions",
                onSearchDropDown(row.caseTitleOptionsFiltered, v)
              )
            }
          />
          {loadingStates[row.id]?.uids && (
            <div style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)', zIndex: 10 }}>
              <div style={{ width: '16px', height: '16px', border: '2px solid #f3f3f3', borderTop: '2px solid #3498db', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
            </div>
          )}
        </div>
      ),

      issueDescription: (
        <TextBox
          value={row.issueDescription}
          error={!!rowErrors.issueDescription}
          title={rowErrors.issueDescription}
          maxLength={1000}
          onChange={v => {
            updateRow(row.id, "issueDescription", v);
            clearFieldError(row.id, "caseTitle");
            debouncedIssueDescApi(row.id, v);
            clearFieldError(row.id, "issueDescription");
          }}
        />
      ),

      contact: (
        <Select
          showSearch
          options={filteredContactOptions[row.id] || dropdown}
          value={row.contact}
          clearIcon={false}
          onChange={(opt: any) => {
            setContactRowId(row.id);
            updateRow(row.id, "contact", opt?.value ? [opt.value] : []);
            clearFieldError(row.id, "contact");
            if(opt?.value === "-1"){
              setOpen(true);
            }
          }}
          onSearch={(v: any) => {
            setFilteredContactOptions(prev => ({
              ...prev,
              [row.id]: onSearchDropDown(dropdown, v)
            }));
          }}
          error={!!rowErrors.contact}
          onClear={() => {
            updateRow(row.id, "contact", []);
            clearFieldError(row.id, "contact");
            setFilteredContactOptions(prev => ({
              ...prev,
              [row.id]: dropdown
            }));
          }}
        />
      ),

      alternateContact: (
        <Select
          showSearch
          clearIcon={false}
          name={`alternate-${row.id}`}
          options={filteredAlternateContactOptions[row.id] || dropdown}
          value={row.alternateContact}
          onChange={(opt: any) => {
            setAlternateContactRowId(row.id);
            updateRow(row.id, "alternateContact", opt?.value ? [opt.value] : []);
            clearFieldError(row.id, "alternateContact");
            if(opt?.value === "-1"){
              setOpenAlternateContactModal(true);
            }
          }}
          onSearch={(v: any) => {
            setFilteredAlternateContactOptions(prev => ({
              ...prev,
              [row.id]: onSearchDropDown(dropdown, v)
            }));
          }}
          onClear={() => {
            updateRow(row.id, "alternateContact", []);
            clearFieldError(row.id, "alternateContact");
            setFilteredAlternateContactOptions(prev => ({
              ...prev,
              [row.id]: dropdown
            }));
          }}
        />
      ),

      equipmentContact: (
        <>
          <Select
            showSearch
            clearIcon={false}
            options={filteredEquipmentContactOptions[row.id] || dropdown}
            value={row.equipmentContact}
            onChange={(opt: any) => {
              setEquipmentContactRowId(row.id);
              updateRow(row.id, "equipmentContact", opt?.value ? [opt.value] : []);
              clearFieldError(row.id, "equipmentContact");
              onSelectChangeHandler(opt, 'UserId', row.id);
              if(opt?.value === "-1"){
                setOpenEquipmentContact(true);
              }
            }
            }
            onSearch={(v: any) => {
              setFilteredEquipmentContactOptions(prev => ({
                ...prev,
                [row.id]: onSearchDropDown(dropdown, v)
              }));
            }}
            error={!!rowErrors.equipmentContact}
            disabled={loadingStates[row.id]?.contact}
            onClear={() => {
              updateRow(row.id, "equipmentContact", []);
              clearFieldError(row.id, "equipmentContact");
              setFilteredEquipmentContactOptions(prev => ({
                ...prev,
                [row.id]: dropdown
              }));
            }}
          />
          {loadingStates[row.id]?.contact && (
            <div style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)', zIndex: 10 }}>
              <div style={{ width: '16px', height: '16px', border: '2px solid #f3f3f3', borderTop: '2px solid #3498db', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
            </div>
          )}
        </>
      ),
     partShippingAddress: (
  <div style={{ position: "relative", width: "100%" }}>
    
    <Select
      clearIcon={false}
      name={`partShippingAddress-${row.id}`}
      options={[
        { value: "-1", label: "Add New Address" },
        ...(row.partShippingAddressOption ? [row.partShippingAddressOption] : [])
      ]}
      value={row.partShippingAddress}
      style={{
        width: "100%",
        paddingRight: row.partShippingAddress?.length > 0 ? "40px" : "10px"
      }}
      onChange={(opt: any) => {
  setPartShippingAddressRowId(row.id);

  if (opt?.value === "-1") {
    updateRow(row.id, "partShippingAddressData", {});
    updateRow(row.id, "partShippingAddress", []);
    updateRow(row.id, "partShippingAddressOption", null);
    setOpenPartShippingModal(true);
  } else {
    updateRow(
      row.id,
      "partShippingAddress",
      opt?.value ? [opt.value] : []
    );
  }
}}
    />
    {row.partShippingAddress?.length > 0 && (
      <div
        style={{
          position: "absolute",
          right: 8,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 10,
          display: "flex",
          alignItems: "center",
          gap: "8px"
        }}
      >
        <div
          style={{
            width: "1px",
            height: "20px",
            backgroundColor: "#666",
            opacity: 0.8
          }}
        />

      <Tooltip
          content={
            <span style={{ whiteSpace: "nowrap" }}>
              Edit Address
            </span>
          }
          placement="leading"
        >
        <IconPencil
          size={16}
          style={{ cursor: "pointer" }}
          onClick={() => {
            setPartShippingAddressRowId(row.id);
            setOpenPartShippingModal(true);
          }}
        />
      </Tooltip>
    </div>
    )}
  </div>
),

      // partShippingAddress: (
      //   <Select
      //     clearIcon={false}
      //     name={`partShippingAddress-${row.id}`}
      //     options={[{value: "-1", label: "Add New Address"}]}
      //     value={row.partShippingAddress}
      //     onChange={(opt: any) => {
      //       setPartShippingAddressRowId(row.id);
      //       updateRow(row.id, "partShippingAddress", opt?.value ? [opt.value] : []);
      //       clearFieldError(row.id, "partShippingAddress");
      //       if(opt?.value === "-1"){
      //           setOpenPartShippingModal(true);
      //         }
      //       }
      //     }
      //     onClear={() => {
      //       updateRow(row.id, "partShippingAddress", []);
      //       clearFieldError(row.id, "partShippingAddress");
      //     }}
      //   />
      // ),
    site: (
      <div style={{ position: "relative", width: "100%" }}>
        <Select
          showSearch
          clearIcon={false}
          name={`site-${row.id}`}
          options={filteredSiteOptions[row.id] || siteSubAccount}
          value={Array.isArray(row.site) ? row.site : []}
          style={{
  width: "100%",
  paddingRight: row.site?.length > 0 ? "36px" : "8px"
}}
          onChange={async (opt: any) => {
            const value = opt?.value;
            updateRow(row.id, "site", value ? [value] : []);
            clearFieldError(row.id, "site");
            if (!value) return;

            const { address, bindPin } = await fetchSiteNameInfo(
              { accountid: value },
              row.id
            );
            updateRow(row.id, "siteAddress", address);
            updateRow(row.id, "bindPinList", bindPin);
          }}
          onSearch={(v: any) => {
            setFilteredSiteOptions(prev => ({
              ...prev,
              [row.id]: onSearchDropDown(siteSubAccount, v)
            }));
          }}
          error={!!rowErrors.site}
          disabled={loadingStates[row.id]?.site}
          onClear={() => {
            updateRow(row.id, "site", []);
            updateRow(row.id, "siteAddress", []);
            clearFieldError(row.id, "site");
            setFilteredSiteOptions(prev => ({
              ...prev,
              [row.id]: siteSubAccount
            }));
          }}
        />
        {row.site?.length > 0 && (
  <div
    style={{
      position: "absolute",
      right: 8,
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 10,
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }}
  >
    <div
      style={{
        width: "1px",
        height: "20px",
        backgroundColor: "#666", 
        opacity: 0.8
      }}
    />

    <Tooltip
      content={
        <span style={{ whiteSpace: "nowrap" }}>
          Click to edit address
        </span>
      }
      placement="top"
    >
      <IconPencil
        size={16}
        style={{ cursor: "pointer" }}
        onClick={() => {
          setSelectedSiteRow(row);
          setOpenSiteModal(true);
        }}
      />
    </Tooltip>
  </div>
)}
  </div>
)



      
    };
  });

  const onSelectChangeHandler = (selectedOption: any, k: any, rowId?: number) => {
    if (k === 'UserId') {
      if (selectedOption.value !== '-1') {
        // Fetch existing contact details and update row data directly
        const payload = {
          contactid: selectedOption.value,
        };
        fetchContactInfo(payload, rowId ?? equipmentContactRowId);
      } else {
        // Reset form for new contact (UserId = [-1])
        setEquipmentContact([-1]);
      }
    }
  }
  const fetchContactInfo = useCallback(async (payload: any, rowId?: number) => {
    try {
      // Set loading state for this specific row
      if (rowId) {
        setLoadingStates(prev => ({
          ...prev,
          [rowId]: { ...prev[rowId], contact: true }
        }));
      }
      
      const data = await fetchContactDetails(dispatch, payload);
      if (rowId) {
        updateRow(rowId, "equipmentContactData", data);
      }
    } catch (err) {
      console.error('Error fetching contact details:', err);
      toast.error("Failed to load contact details. Please try again.");
    } finally {
      // Clear loading state for this row
      if (rowId) {
        setLoadingStates(prev => ({
          ...prev,
          [rowId]: { ...prev[rowId], contact: false }
        }));
      }
    }
  }, [dispatch]);

  return (
    <div className="bulk-upload-table">
      {errorCount > 0 && (
        <div
          style={{
            background: "#fff1f0",
            color: "#cf1322",
            padding: 10,
            borderRadius: 6,
            marginBottom: 12,
            fontWeight: 500
          }}
        >
          {errorCount} field{errorCount > 1 ? "s" : ""} have errors
        </div>
      )}

      <Table className="tbl-bulk-upload" columns={columns} preferences={preferences} data={tableData} />

      <Row>
        <Col className="d-flex justify-content-end mt-4">
          <Button 
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? t("HPI.EditCase.btnSubmit", { defaultValue: "Submit" }) : t("HPI.EditCase.btnSubmit", { defaultValue: "Submit" })}
          </Button>
        </Col>
      </Row>

      {isLoading && <Loader />}

      <Modal 
        closeOnBlur={false}
      show={open} 
      closeButton 
      expanded 
      onClose={() => setOpen(false)}>
        <CreateNewContact 
        countryList={countryList} 
        countryCodes={countryCodes}
        onSave={(data: any) => {
          updateRow(contactRowId, "contactData", data);
          setOpen(false);
        }}
        // onClose={() =>  setOpen(false)}
        
        />
      </Modal>

      <Modal 
        closeOnBlur={false}
      show={openAlternateContactModal} 
      closeButton 
      expanded 
      onClose={() => setOpenAlternateContactModal(false)}>
        <CreateAlternateContact 
        countryList={countryList} 
        countryCodes={countryCodes}
        onSave={(data: any) => {
          updateRow(alternateContactRowId, "alternateContactData", data);
          setOpenAlternateContactModal(false);
        }}
        />
      </Modal>

      <Modal show={openPartShippingModal} 
      closeOnBlur={false}
      closeButton expanded onClose={() => setOpenPartShippingModal(false)}>
        <PartShippingAddressModal 
          key={partShippingAddressRowId + "-" + openPartShippingModal}
          countryList={countryList} 
          countryCodes={countryCodes}
          savedContactsDropDown={savedContactsDropDown}
          initialData={
          rows.find(r => r.id === partShippingAddressRowId)?.partShippingAddressData
            }
          onSave={(data: any) => {
          const label = `${data.FirstName} ${data.LastName}`;
          const value = data.Email || label; // unique value
            updateRow(partShippingAddressRowId, "partShippingAddressData", data);
            updateRow(partShippingAddressRowId, "partShippingAddress", [value]);
            updateRow(partShippingAddressRowId, "partShippingAddressOption", {
           value,
           label
          });
            setOpenPartShippingModal(false);
          }}
          onClose={() => setOpenPartShippingModal(false)}
        />
      </Modal>

      <Modal show={openEquipmentContact} closeOnBlur={false} closeButton expanded onClose={() => setOpenEquipmentContact(false)}>
        <EquipmentContact 
        countryList={countryList} 
        countryCodes={countryCodes} 
        rowid={equipmentContactRowId}
        equipmentContact={equipmentContact} 
        onSave={(data: any) => {
            if (!equipmentContact) return;
          updateRow(equipmentContactRowId, "equipmentContactData", data);
          setOpenEquipmentContact(false);
          }}
        />
      </Modal>
      <AddressModal
        show={openSiteModal}
        initialData={selectedSiteRow?.siteAddress}
        bindPin={selectedSiteRow?.bindPinList}
        countryList={countryList}
        onClose={() => setOpenSiteModal(false)}
        onSave={(data: any) => {
        if (!selectedSiteRow) return;
       updateRow(selectedSiteRow.id, "siteAddress", data);
       setOpenSiteModal(false);
  }}
/>

    </div>
  );
};

export default BulkUploads;
